// views/component/Modal.js
import React, { useEffect } from "react";

function Modal(props) {
  const { open, close, type, popSize, title, description } = props;
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      }
    }
  }, [open]);

  return (
    <>
       {open ? (
        <section className={`adm_com_popup ${type ? type : ''}`} onClick={close}>
          <div className={`pop_container ${popSize ? popSize : ''}`} onClick={(e) => e.stopPropagation()}>
            <button type="button" className="btn_close" onClick={close}></button>
            {title && <h2 className="pop_tit">{title}</h2>}
            {description && <p className="pop_desc">{description}</p>}
            <div className="content_container">
              {props.children}
            </div>
          </div>
          <i className="bg_close" onClick={close}></i>
        </section>
      ) : null}
    </>
  );
}

export default Modal;
